import { computed, reactive, ref, getCurrentInstance, onMounted, watch, nextTick } from 'vue';
import { useValidateControl } from '../../../setup/validateControl';

export const useCellEditor = ({ props, emit }) => {
  const marginSetting = ref(0);
  const errorProvider = reactive({});
  const isEditor = ref(false);
  const cellData = ref(null);
  const isSelected = ref(false);
  const { proxy } = getCurrentInstance();
  proxy._isGridEditor = true;
  const { errorMessage, validate, clearValidate, displayError, displayErrorMissingValue } = useValidateControl({
    props,
  });

  const listeners = computed(() => {
    return {
      [proxy.$ms.constant.CustomEvent.MsKeydown]: (e, value) => {
        emit(proxy.$ms.constant.CustomEvent.MsKeydown, e, value);
      },
      comboboxLoadData: payload => {
        if (props.propsData.comboboxLoadData && typeof props.propsData.comboboxLoadData === 'function') {
          props.propsData.comboboxLoadData(payload, props.dataRow, props.col, props?.propsData?.custom);
        } else {
          emit('comboboxLoadData', payload, props.col);
        }
      },
      paste: (e) => {
        if (proxy.allowCopyFromExcel) {
          emit('pasteInput', e, proxy.col)
        }
      }
    };
  });

  const activeCell = () => {
    isEditor.value = true;
    return new Promise((resolve, reject) => {
      nextTick(() => {
        resolve();
      });
    });
  };

  const inactiveCell = () => {
    isEditor.value = false;
    return new Promise((resolve, reject) => {
      nextTick(() => {
        resolve(proxy);
        //Chạy bất đồng bộ validate sau khi tất cả các action đã thực hiện xong ở resolve
        setTimeout(() => {
          validate(displayErrorMissingValue.value, displayErrorMissingValue.value);
        }, 0);
      });
    });
  };

  const findEditor = () => {
    const inputEl = proxy.$el.querySelector('input') || proxy.$el.querySelector('textarea');
    if (inputEl) {
      setTimeout(() => {
        inputEl.focus();
        inputEl.select();
      }, 0);
    }
  };

  const getValue = () => {
    //ncphuoc: Đoạn này lấy theo cellData khi editor đang mở và lấy theo row khi editor đóng
    return cellData.value || props.dataRow[props.col.dataField];
  };

  /**
   * menu chức năng sao chép
   * dtnga3
   */
  const editorActions = ref([
    // {
    //   text: 'Sao chép số liệu xuống dưới',
    //   id: proxy.$ms.constant.EditorAction.CopyDownRow,
    // },
    // {
    //   text: 'Sao chép số liệu lên trên',
    //   id: proxy.$ms.constant.EditorAction.CopyUpRow,
    // },
    {
      text: 'Sao chép dữ liệu',
      id: proxy.$ms.constant.EditorAction.CopyRow,
    },
  ]);
  /**
   * Thực hiện sao chép số liệu dòng hạch toán
   * dtnga3 (19.05.2023)
   */
  function clickMenuItem(actionId, rowIndex, colIndex) {
    emit('copyActionClick', actionId, rowIndex, colIndex);
  }

  /**
   * custom vị trí của menuContent
   * dtnga3 (31.05.2023)
   */
  function handleMenuShow() {
    if (props.optionMenuLeft && props.optionMenuLeft != 'unset') {
      // Nếu là cột hiển thị cuối cùng thì dịch menu sang trái sao cho k bị đè bởi nút quick chat
      let optionMenu = proxy.$refs.optionMenu?.$el?.getBoundingClientRect() || { x: 0, width: 0 };
      let optionMenuLeft = optionMenu.x;

      // vị trí cạnh bên trái của button quick chat:
      let btnLeft = document.querySelector('.quick-chat-bar')?.getBoundingClientRect().x || 0;

      if (!btnLeft) {
        marginSetting.value = 0;
        return;
      }
      let distance = Math.abs(btnLeft - optionMenuLeft);
      if (distance < props.menuContentWidth) {
        marginSetting.value = distance - props.menuContentWidth;
        return;
      }
    }
    marginSetting.value = 0;
    return;
  }

  return {
    //Flag ô này đang được edit
    isEditor,
    errorProvider,
    isSelected,
    listeners,
    inactiveCell,
    activeCell,
    cellData,
    findEditor,
    errorMessage,
    validate,
    getValue,
    clearValidate,
    displayError,
    editorActions,
    clickMenuItem,
    marginSetting,
    handleMenuShow,
  }; //Chứa error object // //Các event dùng chung //Hàm inactive edit cell // Hamf active edit cell // Data của cell // Tìm editor(thẻ input)
};
